export const totalLiability = (liabilities) =>
  liabilities
    .reduce((accumulator, liability) => liability.value + accumulator, 0)

export const totalRepayments = (liabilities) =>
  liabilities
    .reduce((accumulator, liability) => liability.monthly_repayment + accumulator, 0)
